<!-- Radio group -->
<div class="col-md-12" *ngIf="!multiple">
    <fieldset>
        <legend class="sr-only">
            {{language.selectOneOption}}
        </legend>
        <div class="custom-control custom-radio" *ngFor="let option of options">
            <app-option [option]="option" [schedulequestionid]="schedulequestionid"
                (radioSelected)="OnRadioSelected($event)"></app-option>
        </div>
    </fieldset>
</div>

<!-- Checkbox group -->
<div class="col-md-12" *ngIf="multiple">
<fieldset>
    <legend class="sr-only">
        {{language.selectAllThatApply}}
    </legend>
    <div
      class="custom-control custom-checkbox"
      *ngFor="let option of options"
    >
      <app-option-check
        [option]="option"
        [schedulequestionid]="schedulequestionid"
        (checkchanged)="oncheckchanged($event)"
      ></app-option-check>
    </div>
  </fieldset>
</div> 